import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useOrganisations } from "../Auth/useOrganisations";

import { toast } from "react-toastify";
import InventoryModal from "../Components/InventoryModal";
import EditInventoryModal from "../Components/EditInventoryModal";
import GifLoader from "../Components/loader";
import {
  completeInventory,
  getInventories,
  saveInventoryToAPI,
  updateInventory,
} from "../Services/MenuApi";
import { useUser } from "../Auth/useUser";
import Swal from "sweetalert2";
import moment from "moment";

const Inventaire = () => {
  const { t } = useTranslation();
  const [organisations, , usedOrganisations] = useOrganisations();
  const [inventories, setInventories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInventoryModal, setShowInventoryModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [hasInventoryInProgress, setHasInventoryInProgress] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [filters, setFilters] = useState({
    search: "",
    date_debut: moment().startOf("day").format("YYYY-MM-DD"),
    date_fin: moment().endOf("day").format("YYYY-MM-DD"),
    completed: "",
    page: 1,
    limit: 20,
  });

  const [pagination, setPagination] = useState({
    total: 0,
    pages: 0,
  });

  const user = useUser();
  const infoUser = user.result;

  useEffect(() => {
    if (usedOrganisations) {
      loadInventories();
    }
  }, [usedOrganisations, filters]);

  const loadInventories = async () => {
    try {
      setLoading(true);

      const response = await getInventories(usedOrganisations, filters);
      if (response.success) {
        setInventories(response.data.inventories);
        setPagination({
          total: response.data.pagination?.total || response.data.length,
          pages: response.data.pagination?.totalPages || 1,
        });

        const hasInProgress = response.data.inventories.some(
          (inv) => inv.status === "in_progress",
        );
        setHasInventoryInProgress(hasInProgress);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement des inventaires");
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      page: 1, // reset to first page when filter changes
    }));
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({ ...prev, page: newPage }));
  };

  // Update your save handler
  const handleSaveInventoryAction = async (inventoryData) => {
    try {
      let response;
      // If an _id is present, it's an update.
      // NOTE: You will need to create updateInventoryAPI in your MenuApi.js
      if (inventoryData._id) {
        response = await updateInventory(inventoryData._id, inventoryData);
        console.log("Update API call goes here", inventoryData);
      } else {
        response = await saveInventoryToAPI(inventoryData);
      }

      // Assuming both APIs return standard success
      if (response?.data?.success || true) {
        // removed true when API is ready
        toast.success(
          inventoryData._id
            ? "Inventaire mis à jour"
            : "Inventaire créé avec succès",
        );
        await loadInventories();
        return true;
      }
      return false;
    } catch (error) {
      toast.error("Erreur lors de la sauvegarde de l'inventaire");
      return false;
    }
  };



  const handleCompleteInventory = async (inventoryId) => {
    const result = await Swal.fire({
      title: "Cloturer l'inventaire",
      text: "Êtes-vous sûr de vouloir terminer cet inventaire ? Cette action est irréversible.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, terminer",
      cancelButtonText: "Annuler",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      const data = { completed_by: infoUser.id };
      const response = await completeInventory(inventoryId, data);
      if (response.data.success) {
        toast.success("Inventaire terminé avec succès");
        await loadInventories();
      }
    } catch (error) {
      toast.error("Erreur lors de la complétion de l'inventaire");
    }
  };
  const getStatusBadge = (status) => {
    switch (status) {
      case "completed":
        return <span className="badge badge-success">{t("Terminé")}</span>;
      case "in_progress":
        return <span className="badge badge-warning">{t("En cours")}</span>;
      case "cancelled":
        return <span className="badge badge-danger">{t("Annulé")}</span>;
      default:
        return <span className="badge badge-secondary">{t("Inconnu")}</span>;
    }
  };
  return (
    <section className="content">
      <GifLoader loading={loading} />

      <div className="row">
        <div className="col-12">
          <div className="box">
            <div className="box-body">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <button
                  className="btn btn-danger"
                  disabled={hasInventoryInProgress}
                  onClick={() => {
                    setSelectedInventory(null); // Clear any previous selection
                    setShowInventoryModal(true);
                  }}
                  style={{ width: "100%" }}
                >
                  <i className="fa fa-plus mr-2"></i>
                  {t("Ajouter un inventaire")}
                </button>
              </div>
              <div className="row mb-4">
                <div className="col-12">
                  <div className="box">
                    <div className="box-body">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>{t("Limite")}</label>
                            <select
                              className="form-control"
                              value={filters.limit}
                              onChange={(e) =>
                                handleFilterChange(
                                  "limit",
                                  parseInt(e.target.value),
                                )
                              }
                            >
                              <option value="20">20</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="200">200</option>
                            </select>
                          </div>
                        </div>{" "}
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Date début</label>
                            <input
                              type="date"
                              className="form-control"
                              value={filters.date_debut}
                              onChange={(e) =>
                                handleFilterChange("date_debut", e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Date fin</label>
                            <input
                              type="date"
                              className="form-control"
                              value={filters.date_fin}
                              onChange={(e) =>
                                handleFilterChange("date_fin", e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-center">
                          <div className="form-group mb-0">
                            <button
                              className="btn btn-secondary mr-2"
                              // onClick={handleResetFilters}
                            >
                              <i className="fa fa-redo mr-2"></i>
                            </button>

                            <button
                              className="btn btn-danger"
                              onClick={loadInventories}
                            >
                              <i className="fa fa-search mr-2"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-8"></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Statistics Cards */}
              {/* <div className="row mb-4">
                <div className="col-xl-3 col-lg-6 col-12">
                  <div className="box">
                    <div className="box-body">
                      <div className="d-flex align-items-center">
                        <div
                          className="me-15 mr-2 bg-primary rounded-circle h-50 w-50 l-h-60 text-center"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <span className="text-white font-size-20">
                            <i className="fa fa-clipboard-list"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="mb-0">{inventories.length}</h4>
                          <p className="text-fade mb-0">
                            {t("Total Inventaires")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-6 col-12">
                  <div className="box">
                    <div className="box-body">
                      <div className="d-flex align-items-center">
                        <div
                          className="me-15 mr-2 bg-success rounded-circle h-50 w-50 l-h-60 text-center"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <span className="text-white font-size-20">
                            <i className="fa fa-check-circle"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="mb-0">
                            {
                              inventories.filter(
                                (i) => i.status === "completed"
                              ).length
                            }
                          </h4>
                          <p className="text-fade mb-0">{t("Terminés")}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-6 col-12">
                  <div className="box">
                    <div className="box-body">
                      <div className="d-flex align-items-center">
                        <div
                          className="me-15 mr-2 bg-warning rounded-circle h-50 w-50 l-h-60 text-center"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <span className="text-white font-size-20">
                            <i className="fa fa-spinner"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="mb-0">
                            {
                              inventories.filter(
                                (i) => i.status === "in_progress"
                              ).length
                            }
                          </h4>
                          <p className="text-fade mb-0">{t("En cours")}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-6 col-12">
                  <div className="box">
                    <div className="box-body">
                      <div className="d-flex align-items-center">
                        <div
                          className="me-15 mr-2 bg-info rounded-circle h-50 w-50 l-h-60 text-center"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <span className="text-white font-size-20">
                            <i className="fa fa-users"></i>
                          </span>
                        </div>
                        <div>
                          <h4 className="mb-0">
                            {
                              [
                                ...new Set(
                                  inventories.map((i) => i.created_by?.name)
                                ),
                              ].length
                            }
                          </h4>
                          <p className="text-fade mb-0">{t("Utilisateurs")}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Inventories Table */}
              <div className="row">
                <div className="col-12">
                  <div className="box">
                    <div className="box-body p-0">
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              {" "}
                              <th>{t("Code")}</th>
                              <th>{t("Date")}</th>
                              <th>{t("Statut")}</th>
                              <th>{t("Produits")}</th>
                              <th>{t("Différence Totale")}</th>
                              <th>{t("Créé par")}</th>
                              <th>{t("Actions")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {inventories.length > 0 ? (
                              inventories.map((inventory) => (
                                <tr key={inventory._id}>
                                  <td>
                                    <code>{inventory.code}</code>
                                  </td>{" "}
                                  <td>
                                    {new Date(
                                      inventory.date,
                                    ).toLocaleDateString("fr-FR")}
                                    <br />
                                    <small className="text-muted">
                                      {new Date(
                                        inventory.date,
                                      ).toLocaleTimeString("fr-FR")}
                                    </small>
                                  </td>
                                  <td>{getStatusBadge(inventory.status)}</td>
                                  <td>
                                    <span className="badge badge-info">
                                      {inventory.items?.length || 0}{" "}
                                      {t("produits")}
                                    </span>
                                    {inventory.adjusted_items && (
                                      <div>
                                        <small className="text-muted">
                                          {inventory.adjusted_items}{" "}
                                          {t("ajustés")}
                                        </small>
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        inventory.total_difference > 0
                                          ? "text-success"
                                          : inventory.total_difference < 0
                                            ? "text-danger"
                                            : "text-muted"
                                      }
                                    >
                                      {inventory.total_difference > 0
                                        ? "+"
                                        : ""}
                                      {inventory.summary.total_difference || 0}
                                    </span>
                                  </td>
                                  <td>
                                    {inventory.created_by?.nom +
                                      " " +
                                      inventory.created_by?.prenom}
                                    {/* {inventory.created_by?.email && (
                                      <div>
                                        <small className="text-muted">
                                          {inventory.created_by.email}
                                        </small>
                                      </div>
                                    )} */}
                                  </td>
                                  <td>
                                    <div className="btn-group">
                                      {/* <button
                                        className="btn btn-sm btn-info"
                                        title={t("Détails")}
                                        onClick={() => {
                                          // Show inventory details
                                          toast.info(
                                            `Détails de l'inventaire ${inventory.code}`
                                          );
                                        }}
                                      >
                                        <i className="fa fa-eye"></i>
                                      </button> */}
                                      {/* <button
                                        className="btn btn-sm btn-secondary"
                                        title={t("Imprimer")}
                                        onClick={() => {
                                          // Print inventory
                                          window.print();
                                        }}
                                      >
                                        <i className="fa fa-print"></i>
                                      </button> */}
                                      {inventory.status === "in_progress" && (
                                        <button
                                          className="btn btn-sm btn-primary"
                                          title={t("Modifier")}
                                          onClick={() => {
                                            setSelectedInventory(inventory);
                                            setShowEditModal(true);
                                          }}
                                        >
                                          <i className="fa fa-edit"></i>
                                        </button>
                                      )}
                                      {inventory.status === "in_progress" && (
                                        <button
                                          className="btn btn-sm btn-success"
                                          title={t("Terminer")}
                                          onClick={async () => {
                                            // Complete inventory
                                            handleCompleteInventory(
                                              inventory._id,
                                            );
                                          }}
                                        >
                                          <i className="fa fa-check"></i>
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center py-5">
                                  <i className="fa fa-clipboard-list fa-3x text-muted mb-3"></i>
                                  <h5>{t("Aucun inventaire trouvé")}</h5>
                                  <p className="text-muted">
                                    {t(
                                      "Cliquez sur 'Ajouter un inventaire' pour commencer",
                                    )}
                                  </p>
                                  <button
                                    className="btn btn-danger mt-3"
                                    onClick={() => setShowInventoryModal(true)}
                                  >
                                    <i className="fa fa-plus mr-2"></i>
                                    {t("Créer le premier inventaire")}
                                  </button>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Create Inventory Modal */}
      <InventoryModal
  open={showInventoryModal}
  onClose={() => {
    setShowInventoryModal(false);
    setSelectedInventory(null);
  }}
  onSave={handleSaveInventoryAction}
  organisationId={usedOrganisations}
  selectedInventory={selectedInventory} // Pass the selected data
  t={t}
/>

      {/* Edit Inventory Modal */}
      <EditInventoryModal
        open={showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setSelectedInventory(null);
        }}
        onSave={handleSaveInventoryAction}
        organisationId={usedOrganisations}
        inventory={selectedInventory}
        t={t}
      />
    </section>
  );
};

export default Inventaire;
